(function ($) {

	var $announcement = $("#announcement");
	$(window).on("resize", function() {
		if ($announcement.length > 0) {
			$announcement.css({top: $announcement.outerHeight() * -1});
		}
	}).trigger('resize');

})(jQuery);
